import { externalContentsConstants } from '../constants'
import update from 'react-addons-update';

const initialState = {
    externalContents: [],
    externalContent: {},
    paging: {
        page: 1,
        limit: 10,
        skip: 0,
        sort: { created: -1 },
        total: 0,
        search: '',
        statusCode: [
            'ACTIVE',
            'NOT_ACTIVE',
        ],
    },
    loading: false
}

export const externalContent = (state = initialState, action) => {
    switch (action.type) {
        case externalContentsConstants.GET_EXTERNAL_CONTENT_LIST_SUCCESS:
            return update(state, {
                externalContents: { $set: action.payload.data },
                paging: {
                    // TODO: Change total to paging data
                    total: { $set: action.payload.data.length },
                    page: { $set: parseInt(action.payload.paging.page) },
                    search: { $set: action.payload.query },
                    limit: { $set: action.payload.paging.limit },
                },
                loading: {
                    $set: false,
                },
            });

        case externalContentsConstants.TOGGLE_FILTER:
            return update(state, {
                paging: {
                    statusCode: { $set: action.payload.filter },
                },
            });

        case externalContentsConstants.SET_EXTERNAL_CONTENT_LOADING:
            return update(state, {
                loading: {
                    $set: action.payload
                }
            })

        case externalContentsConstants.SET_EXTERNAL_CONTENT_DATA:
            return update(state, {
                externalContent: {
                    $set: action.payload
                },
            })

        default:
            return state;
    }
}